export const getReturnPath = state => state.rootReducer.loginDetails.returnPath;
export const getUserData = state => state.rootReducer.userDetails;